// Restoring previously removed referral tracking functionality as per product request
// there are no changes has been made in this file we have just reverted it back

import type {ReferralFormParam} from 'src/types/referral-external';
import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {useHistory, Link} from 'src/rerouter';
import {useSelector, useDispatch} from 'react-redux';

import * as reduxApi from 'src/utils/redux-api-v2';
import {validateEmail} from 'src/utils/index';
import {classify} from 'src/utils/classify';
import {
  getReferralUrlSegment,
  DEFAULT_TEXT_COLOR,
} from 'src/utils/referral-external';

import {
  SubTitleSmall,
  CollapsibleCard,
  CollapsibleCardContent,
  FormLabelSmall,
  Button,
  Input,
  ButtonTextMedium,
  SubTitleLarge,
  CircularLoader,
} from '@spaced-out/ui-design-system/lib/components/index';
import css from 'src/components/referral-external/track.css';


export const TrackReferrals = ({
  sourceEmail: emailId,
  utm_medium,
  utm_source,
  referralLinkId,
  isIframe,
}: ReferralFormParam) => {
  const router = useHistory();
  const {brand} = useSelector((state) => state.referralExternal);
  const handleEmailSubmit = (email: string) => {
    router.push({
      pathname: getReferralUrlSegment(referralLinkId),
      query: {action: 'track', source_email: email},
    });
  };

  const queryString = `?iframe=${isIframe.toString()}&utm_source=${
    utm_source || ''
  }&utm_medium=${utm_medium || ''}`;

  const goBackLink = `${getReferralUrlSegment(referralLinkId)}${queryString}`;

  if (!emailId || !validateEmail(emailId)) {
    return (
      <Container>
        <TrackForm
          onSubmit={handleEmailSubmit}
          goBackLink={goBackLink}
          // @ts-expect-error - TS2339 - Property 'color' does not exist on type 'Brand'.
          brandColor={brand.color}
          brandButtonColor={brand.button_color}
        />
      </Container>
    );
  }
  return (
    <Container>
      <TrackDetails
        emailId={emailId}
        goBackLink={goBackLink}
        // @ts-expect-error - TS2339 - Property 'color' does not exist on type 'Brand'.
        brandColor={brand.color}
        brandButtonColor={brand.button_color}
      />
    </Container>
  );
};

type TrackFromProps = {
  onSubmit: (arg1: string) => unknown;
  goBackLink: string;
  brandColor: string | null | undefined;
  brandButtonColor: string;
};
const TrackForm = ({
  onSubmit,
  goBackLink,
  brandColor,
  brandButtonColor,
}: TrackFromProps) => {
  const [email, setEmail] = React.useState('');
  const {t} = useLabelTranslation();

  return (
    <div className={css.trackForm}>
      <SubTitleLarge color="tertiary">{`${t(
        'Hi_there_Please_enter_your_email_ID_to_track_your_referrals_and_their_status',
        'Hi there. Please enter your email ID to track your referrals and their status',
      )}.`}</SubTitleLarge>
      <div className={css.emailInput}>
        <Input
          classNames={{box: css.emailInput}}
          placeholder="johndoe@xyzcompany.com"
          value={email}
          onChange={(e) => setEmail(e.currentTarget.value)}
        />
        {email && !validateEmail(email) && (
          <FormLabelSmall color="danger">
            {t('Please_enter_a_valid_email', 'Please enter a valid email')}
          </FormLabelSmall>
        )}
      </div>
      <Button
        classNames={{wrapper: css.submitButton}}
        type="primary"
        disabled={!validateEmail(email)}
        onClick={() => onSubmit(email)}
        style={{
          backgroundColor: brandButtonColor,
          opacity: !validateEmail(email) ? 0.7 : 'initial',
          boxShadow: `0 0 0 2px ${brandButtonColor}`,
          color: DEFAULT_TEXT_COLOR,
        }}
      >
        {t('Submit', 'Submit')}
      </Button>
      <Link className={css.goBackLink} to={goBackLink}>
        {/* @ts-expect-error - TS2769 - No overload matches this call. */}
        <ButtonTextMedium style={{color: brandColor}}>
          {t('Go_back_to_submit_referrals', 'Go back to submit referrals')}
        </ButtonTextMedium>
      </Link>
    </div>
  );
};

type TrackDetailsProps = {
  emailId: string;
  goBackLink: string;
  brandColor: string | null | undefined;
  brandButtonColor: string | null | undefined;
};

const TrackDetails = ({emailId, goBackLink, brandColor}: TrackDetailsProps) => {
  const [referralsResponse, setReferralsResponse] = React.useState<any>(null);
  const {t, makeKey} = useLabelTranslation();

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(reduxApi.get(`referral/status`, {email_id: emailId})).then(
      (data) => {
        setReferralsResponse(data);
      },
    );
  }, []);

  if (!referralsResponse) {
    return <CircularLoader />;
  }
  return (
    <div className={css.trackDetails}>
      <SubTitleLarge color="tertiary">
        {`${t('Hi', 'Hi')} `}
        {emailId}.{' '}
        {referralsResponse.length !== 0
          ? `${t(
              'Below_are_your_submitted_referrals_and_their_status',
              'Below are your submitted referrals and their status',
            )}:`
          : `${t(
              'No_referrals_has_been_submitted_by_your_email_id',
              'No referrals has been submitted by your email id',
            )}.`}
      </SubTitleLarge>
      <div className={css.referralsContainer}>
        {/* @ts-expect-error - TS7006 - Parameter 'referral' implicitly has an 'any' type. */}
        {referralsResponse.map((referral) => {
          const statuses = referral.referal_status || [];
          const currentStatus = statuses.find(
            // @ts-expect-error - TS7006 - Parameter 'status' implicitly has an 'any' type.
            (status) => status.is_current_state,
          );
          const referredOn = statuses
            // @ts-expect-error - TS7006 - Parameter 'status' implicitly has an 'any' type.
            .find((status) => status.status === 'Referred')
            ?.date?.split(' ')[0];
          return (
            <CollapsibleCard
              title={
                <SubTitleSmall>
                  <span className={css.referralName}>
                    {referral.candidate_name}
                  </span>{' '}
                  | {referral.job_title && `${referral.job_title} |`}{' '}
                  {t(makeKey(currentStatus.status), currentStatus.status)}
                </SubTitleSmall>
              }
            >
              <CollapsibleCardContent className={css.referralDetailContainer}>
                <div className={css.referralDetailRow}>
                  <FormLabelSmall color="secondary">
                    {`${t('Job_Position', 'Job Position')}: `}
                    {referral.job_title}
                  </FormLabelSmall>
                  <FormLabelSmall color="secondary">
                    {`${t('Referred_On', 'Referred On')}: `}
                    {referredOn ?? ''}
                  </FormLabelSmall>
                </div>
                <div className={css.referralDetailRow}>
                  <FormLabelSmall color="secondary">
                    {`${t('Status', 'Status')}: `}
                    {t(makeKey(currentStatus.status), currentStatus.status)}
                  </FormLabelSmall>
                  <FormLabelSmall color="secondary">
                    {`${t('Updated_On', 'Updated On')}: `}
                    {currentStatus.date?.split(' ')[0]}
                  </FormLabelSmall>
                </div>
                <div className={css.timelineContainer}>
                  {statuses.map(
                    ({
                      // @ts-expect-error - TS7031 - Binding element 'status' implicitly has an 'any' type.
                      status,
                      // @ts-expect-error - TS7031 - Binding element 'is_current_state' implicitly has an 'any' type.
                      is_current_state,
                      // @ts-expect-error - TS7031 - Binding element 'is_terminating_state' implicitly has an 'any' type.
                      is_terminating_state,
                      // @ts-expect-error - TS7031 - Binding element 'date' implicitly has an 'any' type.
                      date,
                    }) => {
                      const isInProgress =
                        date &&
                        is_current_state &&
                        !is_terminating_state &&
                        status !== 'Paid';
                      const notCompleted = !date && !is_current_state;
                      const isTerminaState = is_terminating_state;
                      const isCompleted =
                        (date && !is_current_state) ||
                        (is_current_state && status === 'Paid');

                      return (
                        <div
                          className={classify(css.timelineElementContainer, {
                            [css.successLine]: isCompleted,
                            [css.progressLine]: isInProgress,
                            [css.defaultLine]: notCompleted,
                            [css.deleteLine]: isTerminaState,
                          })}
                        >
                          <div
                            className={classify(css.timelineCircle, {
                              [css.inProgress]: isInProgress,
                              [css.notCompleted]: notCompleted,
                              [css.terminaState]: isTerminaState,
                              [css.completed]: isCompleted,
                            })}
                          />
                          <div className={css.timelineContent}>
                            <div
                              className={classify(css.customComponent, {
                                [css.terminaState]: isTerminaState,
                                [css.inProgress]: isInProgress,
                                [css.notCompleted]: notCompleted,
                                [css.completed]: isCompleted,
                              })}
                            >
                              {t(makeKey(status), status)}
                            </div>
                          </div>
                        </div>
                      );
                    },
                  )}
                </div>
              </CollapsibleCardContent>
            </CollapsibleCard>
          );
        })}
      </div>
      <Link to={goBackLink} className={css.goBackLink}>
        {/* @ts-expect-error - TS2769 - No overload matches this call. */}
        <ButtonTextMedium style={{color: brandColor}}>
          {t('Go_back_to_submit_referrals', 'Go back to submit referrals')}
        </ButtonTextMedium>
      </Link>
    </div>
  );
};

// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const Container = (props) => (
  <div className={css.container}>
    <div>{props.children}</div>
  </div>
);
